"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _createStyled = _interopRequireDefault(require("./createStyled"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject()); // Make Icon component from URL source or React.Component
// source: url|Component
// other: icon props


var _default = function _default(_ref) {
  var source = _ref.source,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["source"]);
  var result = null;

  if (typeof source === 'string') {
    // URL
    other.backgroundImage = source;
    result = _react["default"].createElement(Div, {
      styles: _objectSpread({}, other)
    });
  } else if (typeof source === 'function') {
    // Component
    var Component = source;
    result = _react["default"].createElement(Component, other);
  } else if (_react["default"].isValidElement(source)) {
    result = source;
  }

  return result;
};

exports["default"] = _default;